import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';
import authAxios from 'src/modules/shared/axios/authAxios';

type PublishedRow = {id: string; name: string};

const publishedCache = new Map<string, PublishedRow[]>();

export function getCachedPublishedReports(tenantId?: string | null): PublishedRow[] {
  if (!tenantId) return [];
  return publishedCache.get(String(tenantId)) || [];
}

export function setCachedPublishedReports(tenantId: string, rows: PublishedRow[]) {
  publishedCache.set(String(tenantId), Array.isArray(rows) ? rows : []);
}

export default class RealtimeReportService {
  static async create(data) {
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.post(`/tenant/${tenantId}/realtime-report`, {data});
    return response.data;
  }

  static async update(id, data) {
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.put(`/tenant/${tenantId}/realtime-report/${id}`, {
      id,
      data,
    });
    return response.data;
  }

  static async destroyAll(ids) {
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.delete(`/tenant/${tenantId}/realtime-report`, {
      params: {ids},
    });
    return response.data;
  }

  static async find(id) {
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.get(`/tenant/${tenantId}/realtime-report/${id}`);
    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.get(`/tenant/${tenantId}/realtime-report`, {
      params: {filter, orderBy, limit, offset},
    });
    return response.data;
  }

  static async published() {
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.get(`/tenant/${tenantId}/realtime-report/published`);
    return response.data;
  }

  static async schema(modeloTareaIds: string[]) {
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.get(`/tenant/${tenantId}/realtime-report/schema`, {
      params: {modeloTareaIds: (modeloTareaIds || []).filter(Boolean).join(',')},
    });
    return response.data;
  }

  static async listTasks(id, params: any = {}) {
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.post(`/tenant/${tenantId}/realtime-report/${id}/list`, params);
    return response.data;
  }
}
